import { render, staticRenderFns } from "./ShareButton.vue?vue&type=template&id=651fb606&scoped=true"
import script from "./ShareButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShareButton.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ShareButton.vue?vue&type=style&index=0&id=651fb606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651fb606",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CIcon: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CIcon/CIcon.vue').default,CBtn: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CBtn/CBtn.vue').default})
